require('core-js/stable');
require('svg4everybody')();
const _ = require('underscore'),
{ Utils } = require('./vendor/kerneljs'),
Forms = require('./components/forms').Forms,
SearchBar = require('./components/search-bar'),
DropDown = require('./components/dropdown'),
ModalBox = require('./components/modalbox'),
CheckoutBasketParking = require('./components/checkout-basket-parking'),
Accordion = require('./components/accordion'),
MobileNavigation = require('./components/mobile-navigation'),
VideoPlayer = require('./components/video-player'),
//HeroVideo = require('./components/hero-video'),
SearchAhead = require('./components/search-ahead'),
CardGrid = require('./components/card-grid'),
ParkingTimePicker = require('./components/parking-time-picker'),
TabPanes = require('./components/tab-panes'),
MapsPeopleMap = require('./components/maps-people-map'),
StylishTable = require('./components/stylish-table'),
SiteHeader = require('./components/site-header'),
DatePickerPikaday = require('./components/datepicker-pikaday'),
CustomSelect = require('./components/custom-select'),
TagsSelectorOverlay = require('./components/tags-selector-overlay'),
Reveal = require('./components/reveal'),
MasonryLayout = require('./components/masonry-layout'),
Sticky = require('./components/sticky'),
LazySizes = require('lazysizes'),
FilterButton = require('./components/parking-product-filter');

export {
	Forms,
	SearchBar,
	DropDown,
	ModalBox,
	Accordion,
	CheckoutBasketParking,
	MobileNavigation,
	VideoPlayer,
	// HeroVideo,
	SearchAhead,
	ParkingTimePicker,
	CardGrid,
	TabPanes,
	MapsPeopleMap,
	StylishTable,
	// SiteHeader,
	DatePickerPikaday,
	CustomSelect,
	Reveal,
    TagsSelectorOverlay,
	LazySizes,
	Sticky,
	MasonryLayout,
	FilterButton
}